import React from 'react'
import { observer } from 'mobx-react'
import SettingsManagerContext from './contexts/SettingsManagerContext'

/* global step_settings */

class SettingsManager extends React.Component {

  settings = step_settings

  getStepSettings (step) {
    return this.settings[step]
  }

  getInputSettings (input) {
    return this.settings.inputs[input]
  }

  getInputOptionSettings (input, option) {
    let input_settings = this.getInputSettings(input)
    if (typeof input_settings !== 'object' || typeof input_settings.options !== 'object') return false
    return this.settings.inputs[input].options[option]
  }

  getOtherSettings (key, _default) {
    let val = this.settings.other[key]
    return typeof val !== 'undefined' ? val : _default
  }

  render () {
    return (
      <SettingsManagerContext.Provider value={this}>
        <React.Fragment>
          {React.Children.map(this.props.children, child =>
            React.cloneElement(child, child.props.useSettings === true ? { settings: this } : {}))}
        </React.Fragment>
      </SettingsManagerContext.Provider>
    )
  }
}

export default observer(SettingsManager)